
export class LogConfiguration {
schema: string;
tableName: string;
}

